import React from 'react';
import { Box, Text, Textarea } from '@chakra-ui/react';

const PLACEHOLDER = `Paste messy text from PDFs, emails, websites, Word, Excel, ChatGPT, or logs…

Example: lines that were
broken in the middle of a
sentence should become one smooth paragraph.`;

const TextInputPanel = ({ value, onChange, labelId }) => (
  <Box display="flex" flexDirection="column" minH={{ base: '220px', md: '360px' }} flex={1}>
    <Text fontSize="sm" fontWeight="700" color="gray.700" mb={2}>
      Input
    </Text>
    <Textarea
      id={labelId}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={PLACEHOLDER}
      flex={1}
      minH={{ base: '200px', md: '320px' }}
      resize="vertical"
      borderRadius="xl"
      borderColor="gray.200"
      _focus={{ borderColor: 'teal.400', boxShadow: '0 0 0 1px var(--chakra-colors-teal-400)' }}
      fontSize="sm"
      lineHeight="tall"
      bg="white"
      aria-label="Messy text to clean"
    />
  </Box>
);

export default TextInputPanel;
